// extracted by mini-css-extract-plugin
module.exports = {"versionsContainer":"Versions_versionsContainer__fT-mA","divider":"Versions_divider__17fwV"};